module.exports = __webpack_public_path__ + "img/platform_small_bg.19261f1.webp";